import { useState, useEffect } from 'react'
import { apiUrl } from './utils'
import { IaccessLog } from './types'

export function useGetAccessLogById(id: string) {
  const [items, setItems] = useState<IaccessLog[]>([])
  useEffect(() => {
    async function fetchData() {
      var data = await fetch(apiUrl + 'userAPI.php?controller=accessLogController&method=getById', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      }).then((res) => {
        return res.json()
      })
      setItems(data)
    }
    fetchData()
  }, [id])

  return items
}
